import { render, staticRenderFns } from "./locomotive-field-factory.vue?vue&type=template&id=0d6c068a"
import script from "./locomotive-field-factory.vue?vue&type=script&lang=js"
export * from "./locomotive-field-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports